import { NODE_TYPE_OPERAND } from '../../constants';

/**
 * An operand that is a user-provided value.
 */

/**
 * An operand that is a JQL keyword.
 * See <a href="https://confluence.atlassian.com/jiracorecloud/advanced-searching-keywords-reference-765593717.html#Advancedsearching-keywordsreference-EMPTYEMPTY">Advanced searching - keywords reference</a>
 * for more information about operand keywords.
 */

/**
 * An operand that is a function.
 * See <a href="https://confluence.atlassian.com/x/dwiiLQ">Advanced searching - functions reference</a> for more
 * information about JQL functions.
 */

/**
 * A function name used in an operand.
 */

/**
 * An operand that is a list of values.
 */

//
// ---- Operand Union
//

/**
 * Represents the right hand side value of a clause.
 */

export var isOperandNode = function isOperandNode(maybeOperandNode) {
  return maybeOperandNode.type === NODE_TYPE_OPERAND;
};